export default "__VITE_ASSET__jOgXfgSa__"